import MDBox from "components/MDBox";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import {
  Alert,
  AlertTitle,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useEffect } from "react";

export const Success = ({ data, content = null, onChange }) => {
  useEffect(() => {
    const timerId = setTimeout(() => {
      onChange(null);
    }, 2000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);
  let message = "";
  //const color = success===true?"success":"error"
  //const content=success===true?data.data.message:data.response.data.message
  try {
    message = data.data.message;
  } catch (e) {
    message = "invalid message";
  }
  return (
    <MDBox>
      <Alert sx={{ background:"#dcf1df",marginBottom:"1rem", alignItems: "center", fontWeight: 600 }}  severity="success">
      {content !== null ? content : message}
      </Alert>
      {/* <MDAlert color="success" onClick={onChange}>
        {content !== null ? content : message}
      </MDAlert> */}
    </MDBox>
  );
};

function getMsg(content, data) {
  if (content) {
    return content;
  } else {
    try {
      if (data.response.data) {
        const { code, message, errors } = data.response.data;
        if (message) {
          return message;
        } else {
          return JSON.stringify(errors);
        }
      } else {
        if (data.message) {
          return data.message;
        } else {
          return "Invalid Message";
        }
      }
    } catch (error) {
      return "Invalid Message";
    }
  }
}

export const Error_ = ({ data, content = null, onChange }) => {
  let msg = getMsg(content,data)
  return (
    <MDBox>
      <Alert sx={{ background:"#fdd6d1",marginBottom:"1rem", alignItems: "center", fontWeight: 600 }} onClose={()=>onChange(null)} severity="error">
        {msg}
      </Alert>
    </MDBox>
  );
};

export const Error = ({ data, content = null, onChange }) => {
  useEffect(() => {
    const timerId = setTimeout(() => {
      onChange(null);
    }, 2000);
    return () => {
      clearTimeout(timerId);
    };
  }, []);
  let msg = "";
  try {
    const { code, message, errors } = data.response.data;
    if (message) {
      msg = message;
    } else {
      msg = JSON.stringify(errors);
    }
  } catch (e) {
    msg = "invalid message";
  }
  return (
    <MDBox>
      <Alert sx={{ background:"#fdd6d1",marginBottom:"1rem", alignItems: "center", fontWeight: 600 }}  severity="error">
      {content !== null ? content : msg}
      </Alert>
      {/* <MDAlert color="error" onClick={onChange}>
        {content !== null ? content : msg}
      </MDAlert> */}
    </MDBox>
  );
};

export const WarningAlert = (props) => {
  return (
    <>
      <Alert sx={{ fontWeight: 600, width: "100%" }} severity="warning">
        {props.content}
      </Alert>
    </>
  );
};

export const SuccessAlert = (props) => {
  return (
    <Alert sx={{ fontWeight: 600, width: "100%" }} onClose={() => {}} severity="success">
      {props.content}
    </Alert>
  );
};

export const ErrorAlert = (props) => {
  return (
    <>
      <Alert sx={{ alignItems: "center", fontWeight: 600 }} severity="error">
        {props.content}
      </Alert>
    </>
  );
};

export const InfoAlert = (props) => {
  return (
    <>
      <Alert sx={{ alignItems: "center", fontWeight: 600 }} severity="info">
        {props.content}
      </Alert>
    </>
  );
};

export const LoadingAlert = () => {
  return (
    <>
      <Alert sx={{ alignItems: "center", fontWeight: 600, backgroundColor: "#c0d9fc", marginTop:"1rem" }} severity="info">
        Request Processing ...
      </Alert>
    </>
  );
};

export const CustomAlert = () => {
  return (
    <>
      <Alert severity="success" title="1">
        <AlertTitle>Success</AlertTitle>
      </Alert>
      <Alert severity="info">1</Alert>
      <Alert severity="warning">1</Alert>
      <Alert severity="error">1</Alert>
      <Alert variant="outlined" severity="success" title="1">
        1
      </Alert>
      <Alert variant="outlined" severity="info">
        1
      </Alert>
      <Alert variant="outlined" severity="warning">
        1
      </Alert>
      <Alert variant="outlined" severity="error">
        1
      </Alert>
    </>
  );
};

export const InfoDialog = (props) => {
  return (
    <Dialog open={true}>
      <DialogTitle>{props.title}</DialogTitle>
      {props.content && (
        <DialogContent>
          <DialogContentText>{props.content}</DialogContentText>
        </DialogContent>
      )}

      <DialogActions style={{ display: "flex", justifyContent: "center" }}>
        <MDButton
          color="info"
          style={{ width: "4rem" }}
          onClick={() => {
            props.onOk();
          }}
        >
          Save
        </MDButton>
        <MDButton variant="outlined" color="info" style={{ width: "4rem" }} onClick={props.onClose}>
          Close
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export const MessageDialog = (props) => {
  return (
    <Dialog open={true}>
      <DialogTitle>{props.title}</DialogTitle>
      {props.content && (
        <DialogContent>
          <DialogContentText>{props.content}</DialogContentText>
        </DialogContent>
      )}

      <DialogActions style={{ display: "flex", justifyContent: "center" }}>
        <MDButton
          color="info"
          style={{ width: "4rem" }}
          onClick={() => {
            props.onOk();
          }}
        >
          Ok
        </MDButton>
        <MDButton variant="outlined" color="info" style={{ width: "4rem" }} onClick={props.onClose}>
          Close
        </MDButton>
      </DialogActions>
    </Dialog>
  );
};

export const LoadingDialog = (props) => {
  return (
    <Dialog open={true}>
      <DialogTitle>{props.title ? props.title : "Request Processing"}</DialogTitle>
      <DialogContent>
        <DialogContentText display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export const ExportDialog = (props) => {
  return (
    <Dialog open={true}>
      <DialogTitle>{props.title ? props.title : "Exporting"}</DialogTitle>
      <DialogContent>
        <DialogContentText display="flex" justifyContent="center" alignItems="center">
          <CircularProgress />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export const Submitting = () => {
  return (
    <MDBox>
      <MDAlert sx={{ backgroundColor: "white" }} color="info">
        Request Processing <CircularProgress sx={{ marginLeft: 1, color: "white !important" }} />
      </MDAlert>
    </MDBox>
  );
};
